'use client';

import { Video } from 'lucide-react';

import { Button } from '@/components/ui/button';

import { Tooltip } from '@/shared/components/tooltip';
import { COPY } from '@/shared/constants/copies';

import { MAX_RECORDING_TIME } from './constants';
import type { VideoRecordingFieldProps } from './types';
import { VideoRecordingContent } from './video-recording-content';
import { VideoRecordingProvider } from './video-recording-provider';

function VideoRecordingField({
	fieldId,
	editMode = false,
	disabled = false,
	onVideoRecorded,
	onVideoRemoved,
	recordedVideo,
	formId,
	formName,
	userFirstName,
	getVideoPresignedUrl,
	onUploadStateChange,
	onEditModeChange,
	onUnsavedRecordingChange,
	onRecordingStart,
	onRecordingEnd,
	isRecordingBlocked = false,
}: VideoRecordingFieldProps) {
	// In edit mode, show disabled button with tooltip
	if (editMode) {
		return (
			<div className="space-y-4">
				<div className="flex items-center space-x-2">
					<Tooltip text={COPY.fields.videoEditModeTip}>
						<div>
							<Button
								type="button"
								variant="outline"
								className="h-[44px] gap-2 border-border text-sm font-medium text-slate-700 disabled:cursor-not-allowed disabled:opacity-100"
								disabled
							>
								<Video className="h-4 w-4" />
								Start recording{' '}
								<span className="text-xs text-muted-foreground">
									{COPY.fields.videoMaxLength(MAX_RECORDING_TIME)}
								</span>
							</Button>
						</div>
					</Tooltip>
				</div>
			</div>
		);
	}

	return (
		<VideoRecordingProvider
			fieldId={fieldId}
			onVideoRecorded={onVideoRecorded}
			onVideoRemoved={onVideoRemoved}
			recordedVideo={recordedVideo}
			formId={formId}
			formName={formName}
			userFirstName={userFirstName}
			getVideoPresignedUrl={getVideoPresignedUrl}
			onUploadStateChange={onUploadStateChange}
			onEditModeChange={onEditModeChange}
			onUnsavedRecordingChange={onUnsavedRecordingChange}
			onRecordingStart={onRecordingStart}
			onRecordingEnd={onRecordingEnd}
			isRecordingBlocked={disabled || isRecordingBlocked}
		>
			<VideoRecordingContent />
		</VideoRecordingProvider>
	);
}

export default VideoRecordingField;
